// components/Spinner.jsx
import React from 'react';

const Spinner = ({ message = 'Loading...' }) => {
  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className="w-12 h-12 border-4 border-blue-100 border-l-blue-600 rounded-full animate-spin mb-4"></div>
      {message && <p className="text-base text-blue-600 font-medium">{message}</p>}
    </div>
  );
};

export default Spinner;
